import React from 'react';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
    const token = localStorage.getItem('token');  // Retrieve the token from storage

    if (!token) {
        return <Navigate to="/" replace />;  // Redirect to login if no token
    }

    return children;  // Render the protected content if authenticated
};

export default PrivateRoute;
